import * as React from 'react';

const MaxOccupancy = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={22} height={16} viewBox="0 0 22 16" {...props}>
        <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.3}
            transform="translate(1 .5)"
        >
            <circle cx={6.25} cy={4.063} r={3.438} />
            <path d="M.625 14.375a5.625 5.625 0 0 1 11.25 0M11.876 1.18a3.438 3.438 0 1 1-.005 5.762M12.5 8.89a5.63 5.63 0 0 1 6.875 5.485" />
        </g>
    </svg>
);
export default MaxOccupancy;
